/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The type of energy:
 *   * ELECTRICITY
 *   * WATER
 *   * HYDROGEN
 *   * GNL
 *   * GNC
 *   * GNCL
 *   * BIOGNC
 *   * UNDEFINED
 */
export enum EnergyType {
  ELECTRICITY = 'ELECTRICITY',
  WATER = 'WATER',
  HYDROGEN = 'HYDROGEN',
  GNL = 'GNL',
  GNC = 'GNC',
  GNCL = 'GNCL',
  BIOGNC = 'BIOGNC',
  UNDEFINED = 'UNDEFINED'
}
